export default [
    {
        path: 'relatorio-posicao-estoque',
        component: () => import(
            /* webpackChunkName: 'imunizacao-relatorio-posicao-estoque' */
            '@/views/imunizacao/relatorio-posicao-estoque/Index'
        ),
        redirect: 'relatorio-posicao-estoque/index',
        children: [
            {
                name: 'imunizacao-relatorio-posicao-estoque-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'imunizacao-relatorio-posicao-estoque' */
                    '@/views/imunizacao/relatorio-posicao-estoque/List.vue'
                ),
            },
        ],
    },
]